/* eslint filenames/match-exported:"off" -- unable to please the linter */
import Enum from '@square/dashboard-utilities/utils/enum';
import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import Filter from '@square/dashboard-data/models/squareup/rolodex/filter';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';

// TODO (cren@): this should be evenutally deprecated as GroupV2 is deprecated to Segment

export const MAX_GROUP_NAME_LENGTH = 100;
export const Code = new Enum(['SUCCESS', 'FAILURE', 'DUPLICATE']);
export const Error = ProtoBaseModel.extend({
  code: attr(Code),
  debugText: attr(String)
});
export const Type = new Enum(['INVALID', 'MANUAL', 'SMART']);
const GroupV2 = ProtoBaseModel.extend({
  type: attr(Type),
  groupTokenPair: attr(TokenPair),
  merchantToken: attr(String),
  name: attr(String),
  filters: repeated(Filter),
  numCustomers: attr(Number, {
    default: 0
  }),
  numEmailable: attr(Number, {
    default: 0
  }),
  numManual: attr(Number, {
    default: 0
  }),
  hidden: attr(Boolean)
});
export default GroupV2;